import type { AllChatterTableType } from '../../service/chatter-tracking-service'
import { chatterTableColumnTitles } from './columns'

export const getChatterTableSheetData = (data: AllChatterTableType[]) =>
  data.map((item) => ({
    [chatterTableColumnTitles.name]: item.name,
    [`${chatterTableColumnTitles.minutesActive} (Minutes)`]: item.minutesActive,
    [`${chatterTableColumnTitles.minutesInactive} (Minutes)`]:
      item.minutesInactive,
    [chatterTableColumnTitles.totalNetRevenue]: item.totalNetRevenue,
    [`${chatterTableColumnTitles.averageResponseTime} (Seconds)`]:
      item.averageResponseTime,
    [chatterTableColumnTitles.sendMessages]: item.sendMessages,
    [chatterTableColumnTitles.sentPPVs]: item.sentPPVs,
    [chatterTableColumnTitles.boughtPPVs]: item.boughtPPVs,
  }))
